import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Chip from 'libs/chip/Chip'
import Button from 'libs/button/Button'
import MotionDiv from 'libs/motionDiv'
import PaginatedTable from 'libs/table/PaginatedTable'
import QuickAddEditPurchaseOrder from 'libs/quick-add-edits/quick-add-edit-po/QuickAddEditPoPanel'
import PlusIcon from 'assets/icons/camera-page/PlusIcon'
import { hasAccess } from 'utils/utils'
import { formatUnixDate } from 'utils/dateTimeHandlers'
import { useSelector } from 'react-redux'
import { selectSelectedItem } from 'store/redux/navSlice'
import { useGetVendorByIdQuery } from '../vendor-endpoints/vendor.endpoints'
import { CellProps } from 'react-table'
import { PurchaseOrder } from '../vendor-endpoints/vendorTypes'
import { ExtendedColumn } from 'store/services/utilsTypes'

const ViewPurchaseOrders = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  const purchaseOrderAccess = hasAccess('ord', { po: 'e' })
  const purchaseOrderViewAccess = hasAccess('ord', { po: 'v' })
  const plant = useSelector(selectSelectedItem)

  const { data: vendor } = useGetVendorByIdQuery(
    { plant_id: plant?.id, id: id ?? '' },
    {
      skip: !plant?.id || !id,
    },
  )
  const columns: ExtendedColumn<PurchaseOrder>[] = [
    {
      Header: 'Purchase Order ID',
      accessor: 'purchaseOrderID',
      disableSortBy: true,
      width: 150,
      Cell: ({ row }: CellProps<PurchaseOrder>) => {
        const vendor = row?.original
        return (
          <div
            className={`${purchaseOrderViewAccess ? 'hyperlink' : ''}`}
            onClick={() => {
              purchaseOrderViewAccess &&
                vendor?.id &&
                navigate(`/orders/purchase-order/view/${vendor.id}`)
            }}
          >
            {vendor?.purchaseOrderID ?? '-'}
          </div>
        )
      },
    },
    {
      Header: 'Raw Materials',
      accessor: 'products',
      disableSortBy: true,
      width: 150,
      Cell: ({ row }: CellProps<PurchaseOrder>) => {
        const product = row.original?.products?.length
        return (
          <div
            className={`${purchaseOrderViewAccess ? 'hyperlink' : ''}`}
            onClick={() => {
              purchaseOrderViewAccess &&
                row?.original?.id &&
                navigate(`/orders/purchase-order/view/${row.original.id}`)
            }}
          >
            <span>{product} Raw Materials</span>
          </div>
        )
      },
    },

    {
      Header: 'Arrival Date',
      accessor: 'arrivalDate',
      disableSortBy: true,
      width: 100,
      Cell: ({ row }: CellProps<PurchaseOrder>) =>
        formatUnixDate(row.original?.arrivalDate),
    },
    {
      Header: 'Progress',
      accessor: 'status',
      width: 50,
      Cell: ({ row }: CellProps<PurchaseOrder>) => (
        <Chip title={row?.original?.status} />
      ),
    },
  ]

  return (
    <MotionDiv>
      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full justify-between">
          <h5 className="h5">Purchase Orders</h5>
          <div>
            {purchaseOrderAccess && (
              <Button
                startIcon={<PlusIcon />}
                color="primary"
                onClick={() => {
                  setIsPanelOpen(true)
                }}
              >
                {'Add Purchase Order'}
              </Button>
            )}
          </div>
        </div>
        <QuickAddEditPurchaseOrder
          onClose={() => setIsPanelOpen(false)}
          isOpen={isPanelOpen}
        />
        <PaginatedTable
          columns={columns}
          loading={false}
          rows={vendor?.purchaseOrders}
          hidePagination={true}
          emptyMessage={
            'No purchase order found. Please add new purchase order'
          }
        />
      </div>
    </MotionDiv>
  )
}

export default ViewPurchaseOrders
